import { handleResponseOld, makeGet, makePost } from './helpers';

/**
 * @category Taxes API
 * @see fetchTaxStatus
 */
type FetchTaxStatusParams = {
    authToken: string;
    deployment: string;
    invoiceId: string;
};
/**
 * fetches tax status for given invoiceId via Get to Taxes API
 * @function fetchTaxStatus
 * @category Taxes API
 * @param {FetchTaxStatusParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/taxes/sales/invoice/{invoiceid}/enabled
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/z2css6xlxh/resources/a6wfvb/methods/GET
 * @see https://github.com/LIVEauctioneers/FinanceBackend/tree/master/functions/FinanceBackend-GetInvoiceTaxEnabled
 */
const fetchTaxStatus = ({ authToken, deployment, invoiceId }: FetchTaxStatusParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: `sales/invoice/${invoiceId}/enabled`,
            authToken,
            deployment,
            path: '<TAXES-API>',
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

/**
 * @category Taxes API
 * @see updateTaxAddress
 */
type UpdateTaxAddressParams = {
    authToken: string;
    deployment: string;
    invoiceId: string;
    shippingAddress: {
        AddressLine1: string;
        AddressLine2: string;
        City: string;
        Country: string;
        PhoneNumber: string;
        PostalCode: string;
        Region: string;
    };
};
/**
 * updates invoice address for tax purposes via Post to Taxes API
 * @function updateTaxAddress
 * @category Taxes API
 * @param {UpdateTaxAddressParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/taxes/sales/invoice/{invoiceid}/address
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/z2css6xlxh/resources/nvhle3/methods/POST
 * @see https://github.com/LIVEauctioneers/FinanceBackend/tree/master/functions/FinanceBackend-UpdateInvoiceAddress
 */
const updateTaxAddress = ({ authToken, deployment, invoiceId, shippingAddress }: UpdateTaxAddressParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            apiPath: `sales/invoice/${invoiceId}/address`,
            authToken,
            deployment,
            path: '<TAXES-API>',
        });
        request.send({
            InvoiceAddress: shippingAddress,
            InvoiceId: invoiceId,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchTaxStatus,
    updateTaxAddress,
};
